export default __webpack_public_path__ + "static/media/global-setting.814931cc.svg";